import urlExt from '@w/utils/url';
import { STATUS_BAR_HEIGHT } from '@/constants/storage';
import { isHarmony } from '@kd/env';
interface AppInfo {
  area: string;
  channel?: string;
  city: string;
  cuid: string;
  nt: string;
  os: string;
  province: string;
  token: string;
  vc: string;
  host?: string;
  vcname: string;
  appid?: string;
  cname?: string;
  sdk?: number;
  imei?: string;
  devt?: string;
  brand?: string;
  device?: string;
  model?: string;
  lat?: string;
  lon?: string;
  accu?: string;
  gt?: number;
  ca?: number;
  density?: number;
  grade?: number;
  staBarHeight?: number;
}

interface LoginInfo {
  isLogin: boolean | number;
}

type Hybrid = (action: string, params?: any, callback?: () => unknown) => any; // eslint-disable-line

const get = (key: string): string | number => urlExt.getQuery(key);

export const ua: string = window && window.navigator ? window.navigator.userAgent : '';

export const inApp: boolean = ua ? /scancode/i.test(ua) : false;

export const isiOS: boolean = ua ? /(iPhone|iPad)/i.test(ua) : false;

export const isAndroid: boolean = ua ? /Android/i.test(ua) : false;

export const vc = (function () {
  const matchList = /scancode_vc\/(\d+)/g.exec(ua.toLowerCase());
  return matchList !== null && matchList.length >= 2 ? matchList[1] : '';
})();

const statusBarHeight = window.localStorage.getItem(STATUS_BAR_HEIGHT);

export async function getNAAppInfo(hybrid: Hybrid): Promise<{ [key: string]: any }> {  //  eslint-disable-line
  let appInfo: AppInfo | null = null;
  await new Promise(resolve => hybrid('common', resolve)).then(res => {
    appInfo = res as AppInfo;
  });
  if (isAndroid || isHarmony) {
    if (!statusBarHeight) {
      await new Promise(resolve => hybrid('webviewTopHeight', resolve)).then((res: any) => {
        (appInfo as AppInfo).staBarHeight = res.height;
        window.localStorage.setItem(STATUS_BAR_HEIGHT, res.height);
      });
    } else {
      (appInfo as any).staBarHeight = statusBarHeight;
    }
  }
  return appInfo || {};
}

export async function getLoginInfo(hybrid: Hybrid): Promise<number | boolean> {
  let loginInfo: LoginInfo = { isLogin: false };
  await new Promise(resolve => hybrid('is_login', resolve)).then(res => {
    loginInfo = res as LoginInfo;
  });
  return loginInfo.isLogin;
}

export async function getAppInfo(hybrid: Hybrid): Promise<{ [key: string]: any }> { // eslint-disable-line
  let appInfo: {[index: string]: any} = {}  // eslint-disable-line
  const isDev = process.env.NODE_ENV === 'development'
  if (inApp || isDev) {
    appInfo = await getNAAppInfo(hybrid);
    appInfo.isLogin = await getLoginInfo(hybrid);
  } else {
    ['area', 'channel', 'city', 'cuid', 'nt', 'os', 'province', 'token', 'vc', 'vcname', 'grade'].forEach(item => {
      appInfo[item] = get(item);
    });
    appInfo.isLogin = get('login');
  }
  return appInfo;
}
